module.exports = __webpack_public_path__ + "media/images/logo_paytotal_sem_brilho-ba93b407864cd1938fb9f0b534bf0387.png";